import { createFileRoute } from '@tanstack/react-router';

import {
  resolveRange,
  salesReportQueryOptions,
  SalesReportPage,
  salesSearchSchema,
  todayIn,
} from '@/features/reports';

export const Route = createFileRoute('/_authed/_active/s/$storeId/reports/sales')({
  staticData: { crumb: 'reports:tabs.sales', tours: ['reports.sales'] },
  validateSearch: salesSearchSchema,
  loaderDeps: ({ search }) => ({
    range: search.range,
    from: search.from,
    to: search.to,
    interval: search.interval ?? 'day',
  }),
  loader: ({ context, params, deps }) =>
    context.queryClient
      .query({
        ...salesReportQueryOptions(
          params.storeId,
          resolveRange(deps, todayIn(context.store.timezone)),
          deps.interval,
        ),
        staleTime: 'static',
      })
      .catch(() => undefined),
  component: SalesReportPage,
});
